<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :label-width="$root.labelWidth"
      label-position="right"
      v-loading="updating"
    >
      <el-row :gutter="20" align="middle">
        <el-col>
          <el-form-item :label="$t('modules.company.fields.name.label')" prop="name">
            <el-input type="text" v-model.lazy="formData.name" :placeholder="$t('modules.company.fields.name.placeholder')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" align="middle">
        <el-col :md="12" :sm="24">
          <el-form-item :label="$t('modules.company.fields.address.label')" prop="address">
            <el-input type="text" v-model.lazy="formData.address" :placeholder="$t('modules.company.fields.address.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :sm="24">
          <el-form-item :label="$t('modules.company.fields.address2.label')" prop="address2">
            <el-input type="text" v-model.lazy="formData.address2" :placeholder="$t('modules.company.fields.address2.placeholder')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row align="middle" :gutter="20">
        <el-col :md="9" :sm="24">
          <el-form-item :label="$t('modules.company.fields.city.label')" prop="city">
            <el-input type="text" v-model.lazy="formData.city" :placeholder="$t('modules.company.fields.city.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="24">
          <el-form-item :label="$t('modules.company.fields.state.label')" prop="state">
            <el-select
              v-model="formData.state"
              filterable
              remote
              reserve-keyword
              :placeholder="$t('modules.company.fields.state.placeholder')">
              <el-option
                v-for="state in defaults.states"
                :key="state.name"
                :label="state.name"
                :value="state.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="24">
          <el-form-item :label="$t('modules.company.fields.zip.label')" prop="zip">
            <el-input type="text" v-model.lazy.trim="formData.zip" :placeholder="$t('modules.company.fields.zip.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5" :sm="24">
          <el-form-item :label="$t('modules.company.fields.country.label')" prop="country">
            <el-select
              v-model="formData.country"
              filterable
              remote
              reserve-keyword
              :placeholder="$t('modules.company.fields.country.placeholder')">
              <el-option
                v-for="country in defaults.countries"
                :key="country.name"
                :label="country.name"
                :value="country.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" align="middle">
        <el-col>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">{{ $t('buttons.save') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>      
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import formPopulator from '@/mixins/form_populator';
  import validations from '@/utils/validations';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  import USStates from '@/mixins/states_us';
  import Countries from '@/mixins/countries';

  export default {
    name: 'CompanySettingsForm',
    mixins: [formPopulator, Countries, USStates],
    created() {
      this.populateFormWithModel('currentCompany');
      this.defaults.states = this.getStates();
      this.defaults.countries = this.getCountries();
    },
    data() {
      return {
        translationPrefix: 'pages.companySettings',
        rules: {
          name: [
            { ...validations.required },
          ],
        },
        defaults: {
          countries: [],
          states: [],
        },
        formData: {
          name: '',
          address: '',
          address2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
        },
      };
    },
    computed: {
      ...mapGetters('entities/companies', ['currentCompany']),
      updating() {
        return this.$store.getters['entities/companies/isUpdating'](this.currentCompany.uuid);
      },
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch('entities/companies/updateCompany', { id: this.currentCompany.uuid, data: this.formData })
              .then((response) => {
                if (response.status) {
                  showSuccessMessage(this.$t('modules.company.messages.updated'));
                } else {
                  showErrorMessage(response.error);
                }
              });
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/company/CompanySettingsForm.vue